(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/text-input/assets/javascripts/components/text-input.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/text-input/assets/javascripts/components/text-input.trinidad.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(() => {
  "use strict";

  const __webpack_require__ = {};
  __webpack_require__.n = module => {
const getter = module && module.__esModule ? () => module['default'] : () => module;
    __webpack_require__.d(getter, {
      a: getter
    });
    return getter;
  };
  __webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
      }
    }
  };
  __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  let __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (text_input)
  });
  ; 
  const external_React_namespaceObject = window["React"];
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  const _excluded = ["showCharCounter", "errorMessageMin", "errorMessageMax", "errorMessageRequired", "helpMessage", "infoMessage", "isMultiline", "isRequired", "label", "max", "min", "name", "isLessSpace", "onBlur", "onChange", "onFocus", "validateFn", "value"];
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  ;
  const TextInput = _ref => {
    let showCharCounter = _ref.showCharCounter,
      errorMessageMin = _ref.errorMessageMin,
      errorMessageMax = _ref.errorMessageMax,
      errorMessageRequired = _ref.errorMessageRequired,
      helpMessage = _ref.helpMessage,
      infoMessage = _ref.infoMessage,
      isMultiline = _ref.isMultiline,
      isRequired = _ref.isRequired,
      label = _ref.label,
      max = _ref.max,
      min = _ref.min,
      name = _ref.name,
      isLessSpace = _ref.isLessSpace,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      validateFn = _ref.validateFn,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);
    const _ref3 = (0, external_React_namespaceObject.useState)(value ? value.length : 0),
      _ref4 = _slicedToArray(_ref3, 2),
      charsCount = _ref4[0],
      setCharsCount = _ref4[1];
    const validate = (event, value) => {
      const customValidation = validateFn ? validateFn(value) : {
        errorMessage: '',
        isValid: true
      };
      const hasValue = value.length > 0;
      const isValidMin = min === undefined ? true : value.length >= min;
      const isValidMax = max === undefined ? true : value.length <= max;
      let isValid = hasValue && customValidation.isValid && isValidMin && isValidMax;
      let currentErrorMessage = '';
      if (event === 'onSubmit' && isRequired && !hasValue) {
        currentErrorMessage = errorMessageRequired;
      } else if (!customValidation.isValid) {
        currentErrorMessage = customValidation.errorMessage;
      } else if (!isValidMin) {
        currentErrorMessage = errorMessageMin;
      } else if (!isValidMax) {
        currentErrorMessage = errorMessageMax;
      }
      if (event === 'onBlur' || !isRequired) {
        isValid = customValidation.isValid && isValidMin && isValidMax;
        if (value === '') {
          isValid = true;
          currentErrorMessage = '';
        }
      }
      return {
        errorMessage: currentErrorMessage,
        isValid,
        name
      };
    };
    const handleInput = e => {
      const valueLength = e.currentTarget.value.length;
      if (showCharCounter) {
        setCharsCount(valueLength);
      }
    };
    return React.createElement(external_svs_ui_ReactForm_namespaceObject.FormContext.Consumer, null, _ref2 => {
      let form = _ref2.form,
        handleBlur = _ref2.handleBlur,
        handleChange = _ref2.handleChange,
        handleFocus = _ref2.handleFocus,
        register = _ref2.register;
      return React.createElement(external_svs_ui_ReactForm_namespaceObject.ControlGroup, {
        errorMessage: form[name] && form[name].errorMessage,
        hasError: form[name] && !form[name].isValid,
        infoMessage: infoMessage,
        isLessSpace: isLessSpace,
        v2: true
      }, React.createElement(external_svs_ui_ReactForm_namespaceObject.Inputv2, _extends({
        autoCapitalize: "off",
        autoComplete: "on",
        autoCorrect: "off",
        inputHelpText: helpMessage,
        label: label,
        multiline: isMultiline,
        name: name,
        onBlur: e => {
          handleBlur(e, onBlur);
        },
        onChange: e => {
          handleInput(e);
          handleChange(e, onChange);
        },
        onFocus: e => {
          handleFocus(e, onFocus);
        },
        refElem: register(name, validate),
        spellCheck: "false",
        type: "text",
        value: value
      }, props)), showCharCounter && React.createElement("span", {
        className: "text-input-char-counter"
      }, max ? "".concat(charsCount, "/").concat(max) : "".concat(charsCount, " tecken.")));
    });
  };
  TextInput.defaultProps = {
    errorMessageMax: 'Texten är för lång.',
    errorMessageMin: 'Texten är för kort.',
    errorMessageRequired: 'Du måste ange en text.',
    isRequired: true,
    label: 'Text'
  };
  TextInput.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "TextInput",
    "props": {
      "errorMessageMax": {
        "defaultValue": {
          "value": "'Texten \xE4r f\xF6r l\xE5ng.'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "errorMessageMin": {
        "defaultValue": {
          "value": "'Texten \xE4r f\xF6r kort.'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "errorMessageRequired": {
        "defaultValue": {
          "value": "'Du m\xE5ste ange en text.'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isRequired": {
        "defaultValue": {
          "value": "true",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "label": {
        "defaultValue": {
          "value": "'Text'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "helpMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "infoMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isLessSpace": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "isMultiline": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "max": {
        "description": "",
        "type": {
          "name": "number"
        },
        "required": false
      },
      "min": {
        "description": "",
        "type": {
          "name": "number"
        },
        "required": false
      },
      "name": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": true
      },
      "onBlur": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "onChange": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": true
      },
      "onFocus": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "showCharCounter": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "validateFn": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        },
        "required": true
      }
    }
  };
  const text_input = TextInput;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactFormInputs = window.svs.ui.ReactFormInputs || {}).TextInput = __webpack_exports__["default"];
})();

 })(window);